import { render, staticRenderFns } from "./dr-page.vue?vue&type=template&id=7b7bf8c0"
import script from "./dr-page.vue?vue&type=script&lang=js"
export * from "./dr-page.vue?vue&type=script&lang=js"
import style0 from "./dr-page.vue?vue&type=style&index=0&id=7b7bf8c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../player/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports